import React, { useState } from 'react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { getImagePath } from '../../Utils/Utilities';
import ToggleTabs from '../ui/ToggleTabs';

const DemoSection = ({ onDemoOpen, onDemoScreens, onDemoView }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoLang, setVideoLang] = useState('english');
  const isMobile = useIsMobile()
  const handlePlayVideo = (lang) => {
    onDemoOpen?.()
    const selectedLang = lang || videoLang || 'english';
    setVideoLang(selectedLang);
    setShowVideo(true);
    setTimeout(() => {
      const video = document.getElementById('demoVideo');
      if (video) {
        video.load();
        video.play();
      }
    }, 100);
  };

  const handleViewScreens = () => {
    onDemoScreens?.()
    window.open('https://biziverse.com/ERPScreens.pdf', '_blank');
  };

  const demoRef = React.useRef(null);

  React.useEffect(() => {
    window.selectDemoLang = (lang) => {
      const el = document.getElementById('demoSection');
      if (el) {
        window.scrollTo({ top: el.offsetTop - 70, behavior: 'smooth' });
      }
      handlePlayVideo(lang);
    };
    return () => { delete window.selectDemoLang; };
  }, [videoLang]);

  React.useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { onDemoView?.(); observer.disconnect(); }
    }, { threshold: 0.3 });
    if (demoRef.current) observer.observe(demoRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={demoRef} id="demoSection" className={`${!isMobile ? 'bg-background-light' : 'bg-white'} border-top py-12 md:py-16 lg:py-20`}>
      <Container>
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <div className="mb-0">
            <h3 className="text-[30px] md:text-[40px] font-bold secttl mb-0 px-6 md:px-10 pb-6">
              Quick Intro
            </h3>
          </div>

          {/* Description */}
          <div className="mb-10 px-4">
            <p className="text-[14px] md:text-lg text-text-primary">
              Watch our 5 minute Quick Demo Video
            </p>
          </div>

          {/* Video Container */}
          <div className="mb-4 px-2">
            {!showVideo ? (
              isMobile ?
                <img
                  src={getImagePath("/images/ERPDemoVO0530.jpg")}
                  alt="Demo Video Thumbnail"
                  onClick={() => videoLang && handlePlayVideo(videoLang)}
                  className="w-[100%] md:w-[85%] max-w-3xl mx-auto h-auto rounded-[5px] border-[5px] border-[#e5e5e5] shadow-[0_5px_10px_rgba(0,0,0,0.1)] cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_7px_14px_rgba(0,0,0,0.15)]"
                />
                : <img
                  src={getImagePath("/images/ERPDemoVO0530.jpg")}
                  alt="Demo Video Thumbnail"
                  onClick={() => videoLang && handlePlayVideo(videoLang)}
                  className="w-[90%] md:w-[85%] max-w-3xl mx-auto h-auto rounded-[5px] border-[5px] border-[#e5e5e5] shadow-[0_5px_10px_rgba(0,0,0,0.1)] cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_7px_14px_rgba(0,0,0,0.15)]"
                />
            ) : (
              <video
                id="demoVideo"
                controls
                className="w-[90%] md:w-[85%] max-w-3xl mx-auto h-auto rounded-[5px] border-[5px] border-[#e5e5e5] shadow-[0_5px_10px_rgba(0,0,0,0.1)]"
              >
                <source
                  src={getImagePath(
                    videoLang === 'hindi'
                      ? '/Videos/Biziverse_DemoVOHindi.mp4'
                      : '/Videos/Biziverse_DemoVO.mp4'
                  )}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            )}
          </div>

          <div className="mb-7 !mt-5">
            <ToggleTabs
              tabs={[
                { value: 'english', label: 'English' },
                { value: 'hindi', label: 'हिन्दी' },
              ]}
              activeTab={videoLang}
              onTabChange={(lang) => handlePlayVideo(lang)}
            />
          </div>

          {/* Demo Screens Button */}
          <div className="mt-8">
            <Button
              onClick={handleViewScreens}
              size={!isMobile ? "lg" : "default"}
            >
              Demo Screens
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default DemoSection;